var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 680 680",
    width: 680,
    height: 680,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .bigger-line {\n            stroke: #193890;\n            stroke-width: 25;\n            fill: none;\n            stroke-dasharray: 130,165;\n            stroke-dashoffset: 20;\n            animation: big-dash 1s infinite linear;\n        }\n\n        .smaller-line {\n            stroke: #218baf;\n            stroke-width: 25;\n            fill: none;\n            stroke-dasharray: 65,229;\n            stroke-dashoffset: 180;\n            animation: small-dash 0.5s infinite linear;\n        }\n\n        @keyframes small-dash {\n            from {\n                stroke-dashoffset: 180;\n            }\n            to {\n                stroke-dashoffset: -115;\n            }\n        }\n\n        @keyframes big-dash {\n            from {\n                stroke-dashoffset: 315;\n            }\n            to {\n                stroke-dashoffset: 20;\n            }\n        }\n\n        .shp1 { fill: #2c90dd }\n        .shp2 { fill: #1e659b }\n        .shp3 { fill: #6ab1e7 }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bigger-line",
    d: "         M280 70         L321 46         L574 192         L574 485         L320 635         L66 486         L66 193         Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "smaller-line",
    d: "         M321 46         L574 192         L574 485         L320 635         L66 486         L66 193         Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shp1",
    d: "M320 97.51L514.56 210.79L320 322.79L125.44 208.23L320 97.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shp2",
    d: "M335.36 349.03L530.56 236.39L529.92 462.95L336 572.39L335.36 349.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shp3",
    d: "M109.44 237.03L305.28 349.03C305.28 349.03 304.64 574.24 304.64 573.67C304.64 573.1 108.16 461.67 108.16 461.67L109.44 237.03Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0fecd02bac0ce4b663419fa03de32eb2.svg";
export { ForwardRef as ReactComponent };